import React from 'react'
import { ApolloProvider as Provider } from 'react-apollo'
import { createCache, createClient } from '../util/apollo'

const client = createClient(createCache())

const ApolloProvider: React.FC = ({ children }) => <Provider client={client}>{children}</Provider>

export default ApolloProvider
